import { Injectable } from "@angular/core";
import * as collate from "pouchdb-collate";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { PromiseSet } from "shared/auth-services";

@Injectable()
export class AtdlTooltipUiRep {
  private tooltipUiRepMap: Map<string, string> = new Map();
  private _ready: PromiseSet<void> = new PromiseSet<void>();

  public isReady(): Promise<void> {
    return this._ready.get<void>();
  }

  // must be called only by atdl-processor service;
  public reset() {
    this.tooltipUiRepMap.clear();

    if (!this._ready.isPending) {
      this._ready = new PromiseSet<void>();
    }
  }

  // must be called only by atdl-processor service;
  public resolve() {
    this._ready.resolve();
  }

  public setUiRep(k: string, v: string) {
    this.tooltipUiRepMap.set(k, v);
  }

  inlineUiRep(
    algoStrategyName: string,
    strategyParameters: Array<CubiqTS.StrategyParameterImpl>,
  ): Array<CubiqTS.StrategyParameterImpl> {
    return this.asUiRep(algoStrategyName, strategyParameters, false);
  }

  cloneWithUiRep(
    algoStrategyName: string,
    strategyParameters: Array<CubiqTS.StrategyParameterImpl>,
  ): Array<CubiqTS.StrategyParameterImpl> {
    return this.asUiRep(algoStrategyName, strategyParameters, true);
  }

  // this must fail gracefully if not ready
  private asUiRep(
    algoStrategyName: string,
    strategyParameters: Array<CubiqTS.StrategyParameterImpl>,
    clone: boolean = false,
  ): Array<CubiqTS.StrategyParameterImpl> {
    if (typeof algoStrategyName === "string" && Array.isArray(strategyParameters)) {
      return strategyParameters.map((p) => {
        let uiRepKey = collate.toIndexableString([
          algoStrategyName,
          p.parameterName,
          // wiretype often appears as number except when updated by OEAlgoParamsComponent
          // forcing to string for key to acknowedge StrategyParameterImpl 's signature
          p.parameterValue != null ? p.parameterValue.toString() : p.parameterValue,
        ]);

        if (
          p != null &&
          this != null &&
          this.tooltipUiRepMap instanceof Map &&
          this.tooltipUiRepMap.has(uiRepKey)
        ) {
          let uiRep = this.tooltipUiRepMap.get(uiRepKey);
          // logger.out.info(`replacing uiRep: ${p.parameterValue} with ${uiRep}`);
          if (clone) {
            let uiP = Object.assign(new CubiqTS.StrategyParameterImpl(), p);
            uiP.parameterValue = uiRep;
            return uiP;
          } else {
            p.parameterValue = uiRep;
          }
        }

        return p;
      });
    }

    return strategyParameters;
  }
}
